export default [
    {
        name: 'environmentMapTexture',
        type: 'cubeTexture',
        path:
        [
            '/textures/environmentMaps/0/px.jpg',
            '/textures/environmentMaps/0/nx.jpg',
            '/textures/environmentMaps/0/py.jpg',
            '/textures/environmentMaps/0/ny.jpg',
            '/textures/environmentMaps/0/pz.jpg',
            '/textures/environmentMaps/0/nz.jpg'
        ]
    },
    {
        name: 'mapEnvironment',
        type: 'texture',
        path: '/textures/environmentMaps/fishes.jpg'
    },
    {
        name: 'mapTexture',
        type: 'texture',
        path: '/models/LeePerrySmith/color.jpg'
    },
    {
        name: 'normalTexture',
        type: 'texture',
        path: '/models/LeePerrySmith/normal.jpg'
    },
    {
        name: 'leePerrySmithModel',
        type: 'gltfModel',
        path: 'models/LeePerrySmith/LeePerrySmith.glb'
    }
]